export default "__VITE_ASSET__DvidDuYO__"